import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Onlinetaxibookingmumbai() {



  const cardData = {
    keyword: " Online Taxi Booking Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and convenient online taxi booking services in Mumbai, making local travel, airport transfers, and outstation trips easy, fast, and stress-free. Whether you are booking a cab for business meetings, daily commute, family travel, or weekend trips, our professional drivers and well-maintained vehicles ensure a safe and comfortable journey every time. We provide instant online booking, quick pickup, transparent pricing, and 24/7 availability with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all travel needs. With easy booking through website or call, Royal Route Cab is your trusted choice for online taxi booking in Mumbai.",

"topPlaces": [

  {
    "title": "Nashik",
    "description": "Nashik is famous for its vineyards, religious temples, and the sacred Godavari River. It is a popular destination for wine tourism, pilgrimages, and weekend road trips from Mumbai."
  },
  {
    "title": "Goa",
    "description": "Goa is a favorite holiday destination from Mumbai, offering beautiful beaches, Portuguese architecture, vibrant nightlife, water sports, and delicious seafood."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is renowned for the UNESCO World Heritage Sites of Ajanta and Ellora Caves, along with Bibi Ka Maqbara. It is a popular historical and cultural destination."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur is known for the Mahalakshmi Temple, traditional cuisine, historical forts, and cultural heritage. It is a popular religious and leisure travel destination."
  },
  {
    "title": "Matheran",
    "description": "Matheran is Asia's only automobile-free hill station, offering peaceful surroundings, panoramic viewpoints, toy train rides, and pleasant weather throughout the year."
  },
    {
    "title": "Pune",
    "description": "Pune is one of the most popular outstation destinations from Mumbai, known for its historical landmarks, IT hubs, educational institutions, and pleasant weather. It is ideal for business trips, family travel, and weekend getaways."
  },
  {
    "title": "Lonavala",
    "description": "Lonavala is a scenic hill station located between Mumbai and Pune, famous for its waterfalls, lush green valleys, Tiger Point, and Bhushi Dam. It is a favorite weekend getaway for nature lovers."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a beautiful hill station known for its strawberry farms, breathtaking viewpoints, cool climate, and attractions like Venna Lake and Arthur's Seat. It is a popular destination for family vacations and honeymoon trips."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of devotees to the Shri Sai Baba Temple every year. It is a preferred spiritual trip from Mumbai."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town famous for its clean beaches, sea forts, water sports, and relaxing atmosphere, making it one of the most popular weekend destinations near Mumbai."
  }
],






services: [
  {
    name: "Online Taxi Booking Mumbai",
    description: "Online taxi booking Mumbai offers a fast and convenient way to reserve cabs for local, airport, and outstation travel. Customers can book rides instantly with just a few clicks. This service provides flexible options and real-time availability. Secure payment and transparent pricing enhance convenience. It ensures a smooth and hassle-free booking experience."
  },
  {
    name: "Mumbai Cab Booking Online",
    description: "Mumbai cab booking online allows travelers to book cabs anytime from anywhere. This service offers a variety of vehicle options based on travel needs. Instant confirmation and easy booking process make it user-friendly. Suitable for daily commuting and long-distance trips. It ensures reliable service."
  },
  {
    name: "Taxi Booking Website Mumbai",
    description: "Taxi booking website Mumbai provides a centralized platform for easy cab reservations. Customers can compare vehicles, pricing, and availability before booking. This service ensures secure transactions and quick confirmations. Ideal for both personal and corporate travel. It simplifies travel planning."
  },
  {
    name: "Book Cab Online Mumbai",
    description: "Book cab online Mumbai for quick and easy reservations with flexible travel options. This service allows users to choose pickup location, timing, and vehicle type. Instant booking confirmation ensures availability. It is suitable for local and outstation travel. It ensures a hassle-free experience."
  },
  {
    name: "Online Cab Reservation Mumbai",
    description: "Online cab reservation Mumbai offers advance booking options for planned travel. Customers can schedule rides based on their convenience. This service is ideal for airport transfers and business trips. Reliable drivers and clean vehicles enhance the experience. It ensures a smooth journey."
  },
  {
    name: "Instant Taxi Booking Mumbai",
    description: "Instant taxi booking Mumbai provides quick ride confirmation for urgent travel needs. This service ensures immediate availability of vehicles. Ideal for last-minute bookings and emergency travel. Professional drivers ensure timely pickups. It guarantees convenience and speed."
  },
  {
    name: "App Based Cab Booking Mumbai",
    description: "App based cab booking Mumbai allows users to book rides through mobile applications with ease. Features include live tracking, fare estimates, and quick booking. This service is ideal for tech-savvy users and daily commuters. It ensures a seamless booking experience."
  },
  {
    name: "24x7 Online Taxi Booking Mumbai",
    description: "24x7 online taxi booking Mumbai ensures round-the-clock availability for all travel needs. This service is perfect for late-night rides and early morning airport transfers. Instant booking and reliable drivers ensure timely service. It guarantees convenience anytime."
  },
  {
    name: "Airport Taxi Booking Mumbai Online",
    description: "Airport taxi booking Mumbai online provides easy reservations for airport pickup and drop services. Customers can book rides in advance for stress-free travel. Professional drivers ensure timely arrival. It is ideal for business travelers and tourists. It ensures a smooth airport transfer."
  },
  {
    name: "Outstation Taxi Booking Mumbai Online",
    description: "Outstation taxi booking Mumbai online offers easy booking for long-distance travel. Customers can choose one way or round trip packages. Vehicles are well-maintained for highway journeys. Flexible travel plans enhance convenience. It ensures a comfortable journey."
  },
  {
    name: "Local Taxi Booking Mumbai Online",
    description: "Local taxi booking Mumbai online is ideal for city travel including office commutes and daily errands. Quick booking and instant confirmation make it convenient. Professional drivers ensure safe travel. It guarantees a smooth city experience."
  },
  {
    name: "Cheap Online Cab Booking Mumbai",
    description: "Cheap online cab booking Mumbai offers budget-friendly travel options through online platforms. Customers can find affordable rides with transparent pricing. Ideal for cost-conscious travelers. Economical vehicles are available for daily use. It ensures value for money."
  },
  {
    name: "Best Online Taxi Service Mumbai",
    description: "Best online taxi service Mumbai ensures premium booking experience with reliable service and top-quality vehicles. This service focuses on customer satisfaction, safety, and convenience. Multiple vehicle options are available. It guarantees a trusted and comfortable journey."
  },
  {
    name: "Mumbai Cab Booking App",
    description: "Mumbai cab booking app provides a user-friendly platform for booking taxis on mobile devices. Features include quick booking, fare estimates, and ride tracking. This service is ideal for daily commuters and frequent travelers. It ensures a seamless experience."
  },
  {
    name: "Online Taxi Fare Mumbai",
    description: "Online taxi fare Mumbai allows customers to check estimated fares before booking. Transparent pricing helps travelers plan their budget. This service provides multiple options based on vehicle type and distance. It ensures informed decision-making."
  },
  {
    name: "Pre Book Taxi Mumbai",
    description: "Pre book taxi Mumbai allows travelers to schedule rides in advance for planned travel. This service is ideal for airport transfers, business meetings, and early morning trips. Reliable drivers ensure timely arrival. It ensures a stress-free travel experience."
  }
],

tableData: [
  ["Online Taxi Booking Mumbai", "Mumbai Cab Booking Online"],
  ["Taxi Booking Website Mumbai", "Book Cab Online Mumbai"],
  ["Online Cab Reservation Mumbai", "Instant Taxi Booking Mumbai"],
  ["App Based Cab Booking Mumbai", "24x7 Online Taxi Booking Mumbai"],
  ["Airport Taxi Booking Mumbai Online", "Outstation Taxi Booking Mumbai Online"],
  ["Local Taxi Booking Mumbai Online", "Cheap Online Cab Booking Mumbai"],
  ["Best Online Taxi Service Mumbai", "Mumbai Cab Booking App"],
  ["Online Taxi Fare Mumbai", "Pre Book Taxi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Easy Online Taxi Booking in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers a simple and quick online taxi booking service in Mumbai, allowing customers to book cabs instantly from anywhere."
  },
  {
    WhyChooseheading: "Instant Booking Confirmation",
    WhyChoosedescription: "Get quick confirmation for your cab booking with real-time availability and fast response for all travel needs."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing during online booking with no hidden costs or surprises."
  },
  {
    WhyChooseheading: "24/7 Online Cab Booking Availability",
    WhyChoosedescription: "Our online taxi booking service in Mumbai is available 24/7, making it easy to book rides anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Booking Options",
    WhyChoosedescription: "Book cabs online for local city travel, airport transfers, and outstation trips from Mumbai with flexible options."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your requirement."
  },
  {
    WhyChooseheading: "Trusted Online Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for fast booking, reliable service, and smooth travel experience in Mumbai."
  }
]

};

const faqData = [
  { question: "How can I book a taxi online in Mumbai?", answer: "You can easily book a taxi online with Royal Route Cabs through phone or website with instant confirmation." },
  { question: "Is online taxi booking available 24/7?", answer: "Yes, our online taxi booking service in Mumbai is available 24 hours a day." },
  { question: "Do you provide instant booking confirmation?", answer: "Yes, we provide quick confirmation for all online taxi bookings." },
  { question: "Which types of cabs are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book outstation cabs online?", answer: "Yes, you can book both local and outstation cabs online from Mumbai." },
  { question: "Are fares fixed during online booking?", answer: "Yes, we provide transparent pricing with no hidden charges." },
  { question: "Do you provide airport taxi booking?", answer: "Yes, we offer online booking for Mumbai airport pickup and drop services." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended during peak hours and weekends." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Joshi",
    feedback: "Taxi service in Mumbai through Royal Route Cabs was quick and reliable. The cab arrived on time and the ride was smooth and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Online taxi service in Mumbai felt very convenient and well-organized. The driver was professional and the entire journey was hassle-free and safe.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Taxi Booking Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/online-taxi-booking-mumbai.jpg", // replace if needed
  "description": "Book online taxi in Mumbai with Royal Route Cabs for instant, safe, and reliable cab booking. 24x7 online cab service for local, airport, and outstation travel with sedan, SUV, Innova, and luxury cars.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // base booking price (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/online-taxi-booking-mumbai"
  }
};






  return (
    <div>
<Helmet>
  <title>Online Taxi Booking Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book online taxi in Mumbai instantly with Royal Route Cabs. 24x7 cab booking for local, airport, and outstation travel. Safe, affordable & reliable service with all vehicle options."
  />

  <meta
    name="keywords"
    content="online taxi booking mumbai, mumbai cab booking online, taxi booking website mumbai, book cab online mumbai, online cab reservation mumbai, instant taxi booking mumbai, app based cab booking mumbai, 24x7 online taxi booking mumbai, airport taxi booking mumbai online, outstation taxi booking mumbai online, local taxi booking mumbai online, cheap online cab booking mumbai, best online taxi service mumbai, mumbai cab booking app, online taxi fare mumbai, pre book taxi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onlinetaxibookingmumbai;